import type { CSSProperties, ReactNode } from 'react';

export interface CollapsiblePanelProps {
  /** Controla si el contenido se muestra expandido o colapsado */
  open: boolean;
  children: ReactNode;
}

const outerStyle = (open: boolean): CSSProperties => ({
  display: 'grid',
  gridTemplateRows: open ? '1fr' : '0fr',
  transition: 'grid-template-rows 300ms ease-in-out',
});

/**
 * CollapsiblePanel — muestra/oculta contenido con una animación de altura
 * suave, vía CSS puro (`grid-template-rows` 0fr → 1fr). A diferencia de
 * animar `max-height`, no depende de adivinar una altura fija: no hay
 * saltos si el contenido cambia de tamaño mientras está expandido.
 *
 * Componente genérico de la librería `contasis`: no sabe nada de columnas,
 * tablas ni de ningún caso de uso concreto — solo recibe `open` y
 * `children`. El contenido se mantiene siempre montado; es este panel el
 * único responsable de mostrarlo u ocultarlo.
 */
export function CollapsiblePanel({ open, children }: CollapsiblePanelProps) {
  return (
    <div style={outerStyle(open)}>
      <div className="overflow-hidden" aria-hidden={!open}>
        {children}
      </div>
    </div>
  );
}
